import { WitaConnector } from '@/services/repository/connector'

import { AuthExternalRepositoryProps } from './AuthExternalRepository.d'

const ROOT_URL = '/authentication/external'

export const AuthExternalRepository = {
  Login: async function (params: AuthExternalRepositoryProps.Login.Params) {
    const url = ROOT_URL + `/login`
    return await WitaConnector.post<AuthExternalRepositoryProps.Login.Response>(
      url,
      params,
    )
  },
}
